export const enums = {
  pagesStatusType: {
    0: "draft",
    1: "Publiczne",
    2: "Zabezpieczono hasłem",
    3: "Prywatne",
  },

  categoryType: {
    page: "strona",
    cancer: "nowotwór",
    event: "wydarzenie",
    profiling: "profilowanie"
  },

  cancerStatus: [
    {
      name: "aktywny",
      id: "1",
    },
    {
      name: "nieaktywny",
      id: "0",
    },
  ],

  cancerGroups: [
    { id: "nowotwory-piersi", name: "Nowotwory piersi" },
    { id: "nowotwory-ukladu-oddechowego", name: "Nowotwory układu oddechowego" },
    { id: "nowotwory-zenskich-narzadow-plciowych", name: "Nowotwory żeńskich narządów płciowych" },
    { id: "nowotwory-ukladu-pokarmowego", name: "Nowotwory układu pokarmowego" },
    { id: "nowotwory-meskich-narzadow-rozrodczych", name: "Nowotwory męskich narządów rozrodczych" },
    { id: "nowotwory-ukladu-moczowego", name: "Nowotwory układu moczowego" },
    { id: "nowotwory-krwi", name: "Nowotwory krwi" },
    { id: "nowotwory-ukladu-nerwowego", name: "Nowotwory układu nerwowego" },
    { id: "nowotwory-skory", name: "Nowotwory skóry" },
    { id: "nowotwory-glowy-lub-szyi", name: "Nowotwory głowy lub szyi" },
    { id: "nowotwory-tarczycy", name: "Nowotwory tarczycy" },
    { id: "nowotwory-kosci", name: "Nowotwory kości" },
    { id: "miesiaki-i-inne", name: "Mięsaki i inne nowotwory międzybłonka i tkanek miękkich" },
    { id: "inne", name: "Inne" },
  ],
};
